import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Variants } from "framer-motion";
import { Wrapper } from "./loading.style";

export const LoadingComponent = ({ onLoadingComplete }: { onLoadingComplete?: any }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [showText, setShowText] = useState(false);

    useEffect(() => {
        const textTimer = setTimeout(() => {
            setShowText(true);
        }, 2000);

        return () => {
            clearTimeout(textTimer);
        };
    }, []);

    const iconVariants: Variants = {
        hidden: {
            scale: 0,
            opacity: 0,
            rotate: -180
        },
        visible: {
            scale: 1,
            opacity: 1,
            rotate: 0,
            transition: {
                type: "spring",
                stiffness: 150,
                damping: 12,
                duration: 1.5
            }
        },
        pulse: {
            scale: [1, 1.05, 1],
            transition: {
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut"
            }
        }
    };

    const textVariants: Variants = {
        hidden: {
            opacity: 0,
            x: -20
        },
        visible: {
            opacity: 1,
            x: 0,
            transition: {
                duration: 0.8,
                ease: "easeOut"
            }
        }
    };
    return (
        <Wrapper>
            <AnimatePresence>
                {isVisible && (
                    <motion.div
                        className="splash-screen"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        <div className="splash-content">
                            <div className="icon-text-container">
                                <motion.div
                                    className="icon-container"
                                    variants={iconVariants}
                                    initial="hidden"
                                    animate="visible"
                                >
                                    <motion.div
                                        className="app-icon"
                                        animate="pulse"
                                        variants={iconVariants}
                                    >
                                        <svg
                                            width="51"
                                            height="56"
                                            viewBox="0 0 51 56"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M41.6035 0H0V9.39649H41.6035V17.166H0V24.4707V26.5625V46.3848V51.0664V55.7813H17.2324H26.6289V46.3848L36.0918 55.748V55.7813H51V46.3848H39.9765L26.6289 33.1367V33.0703H17.2324V46.3848H9.39646V26.5625H41.6035H51V17.166V9.39649V0H41.6035Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </motion.div>
                                </motion.div>

                                <AnimatePresence>
                                    {showText && (
                                        <motion.div
                                            className="text-container"
                                            variants={textVariants}
                                            initial="hidden"
                                            animate="visible"
                                        >
                                            <h1 className="company-text user-select-none">
                                                Rhombu
                                            </h1>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </Wrapper>
    );
};